import { useEffect, useState } from 'react';
import { axiosPrivate } from '../../axios';
import { apiGifts } from '../../api/apiGifts.api';
import { TopUpPanel } from '../../components/gifts/TopUpPanel';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import DotSpinner from '../../components/shared/DotSpinner';
import chatService from '../../services/chat.service';
import config from '../../config';

export function SendGiftsUser() {
  const location = useLocation();
  const navigate = useNavigate();
  const recipientId = location.state?.recipientId;

  const [userCoins, setUserCoins] = useState(0);
  const [presents, setPresents] = useState([]);
  const [myPresents, setMyPresents] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [loadingGifts, setLoadingGifts] = useState(false);

  const handleSendGift = async (gift) => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      const existingGifts = myPresents.find((g) => g._id === gift._id && g.isBought);

      if (!existingGifts) {
        await axiosPrivate.post('/gifts/buy', {
          giftId: gift._id
        });
      }
      await onSendGift(gift._id);
      fetchUserBalance();
      apiGifts
        .fetchMyGifts(axiosPrivate, setLoadingGifts)
        .then((gifts) => setMyPresents(gifts.filter((gift) => gift.isBought)));
    } catch (error) {
      console.error('Ошибка при отправке подарка:', error);
      toast.error(error.response?.data?.message || 'Ошибка при отправке подарка');
    } finally {
      setIsLoading(false);
    }
  };

  const onSendGift = async (giftId) => {
    if (!recipientId) return;
    try {
      const res = await apiGifts.sendGift(axiosPrivate, { recipientId, giftId });
      if (res.data.data.ok) {
        await handleToFindOrCreateChat();
      }
    } catch (error) {
      console.error('[Roulette] Error sending gift:', error);
      toast.error(error.response.data.message || 'Ошибка отправки подарка');
    }
  };

  const handleToFindOrCreateChat = async () => {
    if (!recipientId) return;
    try {
      const res = await chatService.getChatToUserId(axiosPrivate, recipientId);
      navigate(config.ROUTES.CHATS.TEXT(res.data._id), {
        state: {
          disabled: false
        }
      });
    } catch (error) {
      console.error('[Roulette] getChatToUserId:', error);
      toast.error('Ошибка при попытке открыть чат с пользователем');
    }
  };

  const fetchUserBalance = async () => {
    try {
      const response = await axiosPrivate.get(`/users/me`);
      setUserCoins(response.data.data.wallet.coins || 0);
    } catch (error) {
      console.error('Ошибка при загрузке баланса:', error);
    }
  };

  useEffect(() => {
    fetchUserBalance();

    apiGifts.fetchGifts(axiosPrivate, setLoadingGifts).then(setPresents);
    apiGifts
      .fetchMyGifts(axiosPrivate, setLoadingGifts)
      .then((gifts) => setMyPresents(gifts.filter((gift) => gift.isBought)));
  }, []);

  return (
    <>
      <div className="flex-1 p-4 mb-[45px]">
        {loadingGifts && <DotSpinner className="m-auto" />}

        <div className="grid grid-cols-3 gap-2 pb-4">
          {presents.map((gift, index) => {
            return (
              <div key={gift._id} className="flex flex-col h-full">
                <div className="flex-1 flex flex-col items-center pt-3 px-1 pb-1 bg-white/10 rounded-[13px]">
                  <img src={gift.imageUrl} className={`w-[50px] h-[50px]`} />
                  <p className="text-[11px] text-center mt-1 text-white">{gift.title}</p>

                  <div className="flex items-center gap-1 mt-1">
                    <img src="/icons/coin.svg" className="w-[11px] h-[11px]" />
                    <span className="text-[11px] text-white">{gift.priceCoins}</span>
                  </div>
                </div>

                <button
                  className="w-full h-[24px] bg-[#A1F69E] flex items-center justify-center rounded-full mt-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSendGift(gift);
                  }}
                  disabled={isLoading}
                >
                  <span className="text-[#010D0D] text-[15px] font-medium">
                    {isLoading ? 'Отправка...' : 'Подарить'}
                  </span>
                </button>
              </div>
            );
          })}
        </div>
        {presents.length === 0 && !loadingGifts && (
          <div className="flex flex-col items-center justify-center py-12">
            <div className="text-[48px] mb-4">🎁</div>
            <p className="text-white/60 text-[16px] text-center font-raleway">Подарки временно недоступны</p>
          </div>
        )}
      </div>

      <div className="fixed bottom-0 left-0 right-0">
        <TopUpPanel userCoins={userCoins} />
      </div>
    </>
  );
}
